import React from "react";

import { useFlag } from "utils/hooks";
import "./style.scss";

export default function Snowfall() {
  const { active: grinchActive } = useFlag("grinch");
  const date = new Date();

  // Christmas only, or grinch activated
  if (grinchActive || date.getMonth() !== 11 || ![24, 25].includes(date.getDate())) {
    return null;
  }

  const snowFlakes = new Array(200).fill(null).map((_, index) =>
    <div className="snow" key={index} />
  );

  return (
    <div className="snowfall">
      {snowFlakes}
    </div>
  );
}
